var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "operations-buttons" },
    [
      !_vm.isLoading && !_vm.response
        ? _c("div", [
            _c(
              "button",
              {
                class: [
                  "button is-button-secondary is-rounded",
                  _vm.isUploadActive ? "is-primary" : "",
                ],
                attrs: {
                  id: "operations-upload-button",
                  disabled: !_vm.checkUserFeature(
                    "element.operations.button.cargar"
                  ),
                },
                on: {
                  click: function ($event) {
                    _vm.isUploadActive = !_vm.isUploadActive
                  },
                },
              },
              [
                _vm._m(0),
                _c("span", [_vm._v(_vm._s(_vm.$t("operationsCharge")))]),
              ]
            ),
          ])
        : _vm._e(),
      _vm.isUploadActive && !_vm.isLoading
        ? _c("div", { class: [_vm.isUploadActive ? "show" : "hide"] }, [
            !_vm.file && !_vm.response
              ? _c(
                  "div",
                  {
                    class: [
                      "dropZone card-item shadowless",
                      _vm.dragging ? "dropZone-over" : "",
                    ],
                    on: {
                      dragenter: function ($event) {
                        _vm.dragging = true
                      },
                      dragleave: function ($event) {
                        _vm.dragging = false
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropZone-info",
                        on: { drag: _vm.onChange },
                      },
                      [
                        _c("span", {
                          staticClass: "fa fa-cloud-upload dropZone-title",
                        }),
                        _c("span", { staticClass: "dropZone-title" }, [
                          _vm._v(_vm._s(_vm.$t("uploadFile"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "dropZone-upload-limit-info" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("fileShouldBe"))),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("fileShouldHaveSize"))),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c("input", {
                      attrs: {
                        id: "operations-process-fileUpload",
                        type: "file",
                      },
                      on: { change: _vm.onChange },
                    }),
                  ]
                )
              : _vm.file && !_vm.response
              ? _c(
                  "div",
                  { staticClass: "dropZone-uploaded card-item shadowless" },
                  [
                    _c("div", { staticClass: "dropZone-uploaded-info" }, [
                      _vm.extension !== "xlsx"
                        ? _c(
                            "div",
                            {
                              staticClass: "dropZone-title",
                              attrs: {
                                id: "operations-process-error-format-title",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("fileDoesNotHaveFormat")) +
                                  " "
                              ),
                              _c("div", { staticClass: "has-text-centered" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-button-secondary is-rounded m-1",
                                    attrs: {
                                      id: "operations-charge-again",
                                      type: "button",
                                    },
                                    on: { click: _vm.removeFile },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("retry")) + " ")]
                                ),
                              ]),
                            ]
                          )
                        : _vm.extension === "xlsx" && !_vm.operations.length
                        ? _c(
                            "div",
                            {
                              staticClass: "dropZone-title",
                              attrs: { id: "operations-process-error-title" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.fetch.message ||
                                      _vm.$t("fileDoesNotHaveOperations")
                                  ) +
                                  " "
                              ),
                              _c("div", { staticClass: "has-text-centered" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-button-secondary is-rounded m-1",
                                    attrs: {
                                      id: "operations-charge-xlsx-again",
                                      type: "button",
                                    },
                                    on: { click: _vm.removeFile },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("retry")) + " ")]
                                ),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "dropZone-title",
                              attrs: { id: "operations-process-success" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("fileUploadedSuccessfully")) +
                                  " "
                              ),
                            ]
                          ),
                      _c("div", { staticClass: "uploadedFile-info" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("fileName")) +
                              " " +
                              _vm._s(_vm.file.name)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("fileSize")) +
                              " " +
                              _vm._s(_vm.file.size / 1000000) +
                              " MB"
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("fileExtension")) +
                              " ." +
                              _vm._s(_vm.extension)
                          ),
                        ]),
                      ]),
                      _vm.operations.length
                        ? _c("div", { staticClass: "process-operations" }, [
                            _c("div", { staticClass: "has-text-centered" }, [
                              _c("p", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("willBeProccessed")) + " "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.operations.length) +
                                      " " +
                                      _vm._s(_vm.$t("operations"))
                                  ),
                                ]),
                                _vm._v(". "),
                                _c("br"),
                              ]),
                              _c("p", [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("areYouSure")) + " "
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-secondary is-rounded m-1",
                                  attrs: { type: "button" },
                                  on: { click: _vm.removeFile },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary is-rounded m-1",
                                  attrs: {
                                    id: "operation-proccess-button",
                                    type: "button",
                                  },
                                  on: { click: _vm.process },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("process")) + " ")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm.response
              ? _c(
                  "div",
                  {
                    staticClass:
                      "dropZone-uploaded card-item shadowless process-operations",
                  },
                  [
                    _c("div", [
                      _vm._v(" " + _vm._s(_vm.$t("wereCreated")) + " "),
                      _c("strong", [_vm._v(_vm._s(_vm.response.successes))]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("successOperations")) +
                          ", " +
                          _vm._s(_vm.$t("failedOperations")) +
                          " "
                      ),
                      _c("strong", [
                        _vm._v(" " + _vm._s(_vm.response.failures) + " "),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("operations")) + ". "),
                    ]),
                    _c(
                      "b-button",
                      {
                        staticClass: "show-response-details-button",
                        attrs: { rounded: "", type: "is-primary is-light" },
                        on: {
                          click: function ($event) {
                            return _vm.showResponseDetails()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "content-title" }, [
                          _vm._v(_vm._s(_vm.$t("seeDetail"))),
                        ]),
                        _vm._v(" "),
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: _vm.responseDetails
                              ? "angle-up"
                              : "angle-down",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.responseDetails
                      ? _c(
                          "div",
                          {
                            staticClass: "response-details",
                            attrs: { id: "response-details" },
                          },
                          [
                            _vm._l(
                              _vm.response.responses.filter(
                                (op) => !!op.success
                              ),
                              function (operation) {
                                return _c(
                                  "li",
                                  { key: operation.companyOperationId },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          `${
                                            _vm.$t("operationWasCreated") +
                                            " " +
                                            operation.companyOperationId
                                          }`
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._l(_vm.response.errors, function (message) {
                              return _c(
                                "li",
                                { key: message, staticClass: "response-error" },
                                [_vm._v(" " + _vm._s(message) + " ")]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        staticClass: "button is-button-primary is-rounded",
                        attrs: {
                          id: "operation-finish-button",
                          type: "button",
                        },
                        on: {
                          click: function ($event) {
                            ;(_vm.response = undefined),
                              (_vm.isUploadActive = false),
                              _vm.close()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.isLoading && !_vm.hide
        ? _c(
            "div",
            { staticClass: "columns mt-1" },
            [
              _c("FindEntitiesInput", {
                attrs: {
                  id: "operations-search-text",
                  placeholder: _vm.$t("searchOperations"),
                  expanded: true,
                  finder: _vm.finder,
                },
                on: {
                  select: function ($event) {
                    return _vm.$emit(
                      "clicked-on-filtered-operation",
                      $event.companyOperationId
                    )
                  },
                },
              }),
              _c(
                "button",
                {
                  class: [
                    "button is-button-secondary is-rounded ml-1",
                    _vm.isUploadActive ? "is-primary" : "",
                  ],
                  attrs: {
                    id: "operations-refresh-button",
                    disabled: !_vm.checkUserFeature(
                      "element.operations.button.refresh"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("clicked-on-refresh")
                    },
                  },
                },
                [_vm._m(1)]
              ),
              _c(
                "b-dropdown",
                {
                  staticClass: "ml-2",
                  attrs: { "aria-role": "list" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function ({ active }) {
                          return _c(
                            "button",
                            {
                              staticClass: "button is-primary",
                              attrs: { id: "filter-button-dropdown" },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.selectedOptions))]),
                              _c("b-icon", {
                                attrs: {
                                  icon: active ? "angle-up" : "angle-down",
                                },
                              }),
                            ],
                            1
                          )
                        },
                      },
                    ],
                    null,
                    false,
                    3631261915
                  ),
                  model: {
                    value: _vm.selectedOptions,
                    callback: function ($$v) {
                      _vm.selectedOptions = $$v
                    },
                    expression: "selectedOptions",
                  },
                },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: {
                        id: "filter-button-all",
                        value: _vm.$t("allFilter"),
                        "aria-role": "listitem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("all-filtered")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("allFilter")) + " ")]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: {
                        id: "filter-button-mortgage",
                        value: _vm.$t("mortgageFilter"),
                        "aria-role": "listitem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("mortgage-filtered")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("mortgageFilter")) + " ")]
                  ),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: {
                        id: "filter-button-sme",
                        value: _vm.$t("smeFilter"),
                        "aria-role": "listitem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("sme-filtered")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("smeFilter")) + " ")]
                  ),
                  _vm.$i18n.locale === "br"
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            id: "filter-button-home-equity",
                            value: _vm.$t("homeEquityFilter"),
                            "aria-role": "listitem",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("home-equity-filtered")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("homeEquityFilter")) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: {
                        id: "filter-button-complementary",
                        value: _vm.$t("complementaryFilter"),
                        "aria-role": "listitem",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("complementary-filtered")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("complementaryFilter")) + " ")]
                  ),
                  _vm.$i18n.locale === "cl"
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            id: "filter-button-parking",
                            value: _vm.$t("parkingFilter"),
                            "aria-role": "listitem",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("parking-filtered")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("parkingFilter")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoading ? _c("Spinner") : _vm._e(),
      _vm.isLoading
        ? _c("div", [
            _vm._v(
              " " +
                _vm._s(
                  `${
                    _vm.$t("processing") +
                    " " +
                    _vm.currentOperation.companyOperationId
                  }`
                )
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-upload" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fa-solid fa-arrows-rotate" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }